import { Box, Stack, Typography } from '@mui/material';
import {
  Edit,
  EditContextProvider,
  Form,
  NumberInput,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  required,
  useEditController,
  useNotify,
  useTranslate,
} from 'react-admin';
import { Resources } from '../../resource';
import { PermissionGuard } from 'src/routes/components/permission-guard';

export function TurnkeyConfigForm() {
  const translate = useTranslate();
  const notify = useNotify();

  const controller = useEditController({
    resource: Resources.tunkeySetups,
    id: 1,
  });

  const { record, isLoading, error, save } = controller;

  console.log(controller);

  if (isLoading) return <>Loading...</>;
  if (error) return <>Error</>;
  if (!record) return <>Record not found</>;

  return (
    <EditContextProvider value={controller}>
      <Edit
        resource={Resources.tunkeySetups}
        id={1}
        mutationMode="pessimistic"
        transform={(data) => data}
        mutationOptions={{
          onSuccess: () => {
            notify(translate('module.feeManagement.updateSuccess'), { type: 'success' });
            controller.refetch?.();
          },
          onError: (error: any) => {
            const errorCode = error?.body?.code || error?.code;
            switch (errorCode) {
              case 'INTERNAL_SERVER_ERROR':
                notify(error?.message, { type: 'error' });
                break;
              default:
                notify(error?.message ?? translate('module.feeManagement.unknownErrorUpdate'), {
                  type: 'error',
                });
                break;
            }
          },
        }}
        sx={{
          backgroundColor: 'transparent',
          boxShadow: 'none',
          borderRadius: 0,
          p: 0,
          '& .MuiPaper-root': {
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
        }}
      >
        <Form defaultValues={record} disableInvalidFormNotification>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            alignItems={{ xs: 'center', sm: 'center' }}
          >
            <Typography variant="body2" sx={{ flexBasis: '15%', flexShrink: 0, mt: -3 }}>
              {translate('Public Key')}
            </Typography>
            <Box sx={{ flexGrow: 1 }}>
              <TextInput source="publicKey" label="" fullWidth />
            </Box>
          </Stack>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            alignItems={{ xs: 'center', sm: 'center' }}
          >
            <Typography variant="body2" sx={{ flexBasis: '15%', flexShrink: 0, mt: -3 }}>
              {translate('Private Key')}
            </Typography>
            <Box sx={{ flexGrow: 1 }}>
              <TextInput source="privateKey" label="" fullWidth />
            </Box>
          </Stack>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            alignItems={{ xs: 'center', sm: 'center' }}
          >
            <Typography variant="body2" sx={{ flexBasis: '15%', flexShrink: 0, mt: -3 }}>
              {translate('Organization ID')}
            </Typography>
            <Box sx={{ flexGrow: 1 }}>
              <TextInput source="organizationId" label="" fullWidth />
            </Box>
          </Stack>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            alignItems={{ xs: 'stretch', sm: 'center' }}
            spacing={2}
            mb={1}
          >
            <PermissionGuard resource="turnkey-config" action="update" fallback={<></>}>
              <SaveButton />
            </PermissionGuard>
          </Stack>
        </Form>
      </Edit>
    </EditContextProvider>
  );
}
